import Dialog from "../shared/Dialog";
import Icon from "../shared/Icon";
import BuyOpenInAppDialog from "./BuyOpenInAppDialog";

export default function HomeAddRepoButton() {
	return (
		<div className="footer-action-button">
			<button type="button" className="btn" onClick={() => Dialog.show(<BuyOpenInAppDialog type="add-repo" />)}>
				<Icon name="package" />
				Re-add Chariz Repository
			</button>
		</div>
	);
}
